import { get as nestedGet } from 'nested-property'
import { Address } from '../../types'
import { addressToString } from '../data'

const getAddressPartValue = (partPath: string, address: Address): string | undefined => {
  switch (partPath) {
    case 'address':
      return addressToString(address)
    case 'address2':
      return addressToString(address, true)
    case 'streetAddress':
      return address.streetAddress
    case 'streetAddress2':
      return address.streetAddress2
    case 'fullStreetAddress':
      return `${address.streetAddress}${address.streetAddress2 ? ` ${address.streetAddress2}` : ''}`
    case 'city':
      return address.city
    case 'state':
      return address.state
    case 'zip':
      return address.zip
    default:
      return undefined
  }
}

// eg: address, address2, address.address, address.address2, address.streetAddress, etc.
export const getAddressValue = (
  basePath: string,
  addressPath: string,
  address: Address | undefined,
): string | undefined => {
  const [fieldPath, partPath] = addressPath.split('.')
  if (!address) return undefined
  // if no path provided, return full address
  if (!fieldPath) return undefined
  if (partPath) return getAddressPartValue(partPath, address)
  switch (fieldPath) {
    case basePath:
      return addressToString(address)
    case `${basePath}2`:
      return addressToString(address, true)
    default:
      return nestedGet(address, fieldPath)
  }
}
